import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import { toGetDonationMethods } from "../../../apis/actions/donation.actions";
import Loader from "../../../biblio/Loader/Loader";
import MenuItemLayout from "./MenuItemLayout";
import banner from "../../../assets/images/intern_banner.png";
import heroMobile from "../../../assets/images/intern-mob.png";
import { Col, Row } from "antd";
import DonationMethodCard from "../../../biblio/Cards/DonationMethodCard";
import PaginationComponent from "../../../biblio/Pagination/PaginationComponent";
import { scroll } from "../../../components/utils/utils";

const DonationMethods = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);

  const { donationMethods, loading } = useSelector(
    (state: RootState) => state.donation
  );

  const [currentPage, setCurrentPage] = useState(1);

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };

  useEffect(() => {
    dispatch(toGetDonationMethods());
  }, [dispatch]);

  const itemPerPage = 8;
  const startIndex = (currentPage - 1) * itemPerPage;
  const allDonationMethods = donationMethods.slice(
    startIndex,
    startIndex + itemPerPage
  );

  if (loading) return <Loader />;

  return (
    <MenuItemLayout
      mobileImage={heroMobile}
      title="الرئيسية"
      subTitle={"الحسابات البنكية"}
      urlImage={banner}
      className="takaful--our-story"
    >
      <Row
        dir="rtl"
        gutter={[16, 16]}
        className="takaful--reports-container"
        ref={currentRef}
        style={{ margin: "1.5rem" }}
      >
        {allDonationMethods?.map((method: any, index: number) => (
          <Col
            key={method.bank_name || index}
            xxl={6}
            xl={8}
            lg={12}
            md={12}
            sm={24}
            xs={24}
            style={{ marginTop: "1rem" }}
          >
            <DonationMethodCard method={method} />
          </Col>
        ))}
      </Row>
      <div className="takaful--pagination-container">
        {donationMethods && donationMethods.length > itemPerPage && (
          <PaginationComponent
            active={currentPage}
            total={donationMethods.length}
            itemPerPage={itemPerPage}
            scroll={() => scroll(currentRef)}
            setActive={(nb) => updateActive(nb)}
          />
        )}
      </div>
    </MenuItemLayout>
  );
};

export default DonationMethods;
